// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1bXJh","footer":"ChangeClinic_footer__1b-qi"};